/* ITC CART REBUILD 2026-09-14 - variant-aware delivery estimate.
 *
 * Rewritten from the 2026-09-13 version, which had two faults:
 *
 *   1. It used document.querySelector('[data-itc-variant-map]') and
 *      document.querySelector('[data-itc-delivery]'), so on any page carrying more
 *      than one delivery block EVERY block read the FIRST block's variant map.
 *      One product's delivery time could be shown under a different product.
 *      Now: each block is initialised on its own and only ever reads its OWN map,
 *      which lives inside that block.
 *
 *   2. It added a 'change' listener to the whole document in capture mode, so a
 *      change anywhere on the page re-rendered the estimate.
 *      Now: it listens only to the form the block sits inside.
 *
 * Never hides a slow colour. If a faster colour of the SAME product exists for this
 * visitor's country, it adds one short line naming it. No pressure, nothing removed.
 */
(function () {
  'use strict';

  var INIT = 'itcDeliveryReady';

  function D() { return window.ITC_DELIVERY || null; }

  function windowFor(cv, cc, shopifyVariantId) {
    var d = D();
    if (!d) return null;
    var bucket = (shopifyVariantId && d.overrides && d.overrides[String(shopifyVariantId)])
                 || d.buckets[String(cv)] || 'X';
    var perCountry = d.times[cc] || d.times.DEFAULT;
    var w = perCountry && perCountry[bucket];
    if (!w) return null;
    return { lo: w[0], hi: w[1], bucket: bucket, madeIn: d.legend[bucket] };
  }

  function sentence(w, countryName, cc) {
    if (!w) return 'Made to order. Delivery calculated at checkout.';
    var where;
    if (w.bucket === 'U' && cc !== 'US') where = 'Made in the US, arrives';
    else if (w.bucket === 'C') where = 'Made in China, arrives';
    else where = 'Arrives';
    return 'Made to order. ' + where + ' in ' + w.lo + '–' + w.hi +
           ' business days to ' + countryName + '.';
  }

  function initProduct(root) {
    if (root.dataset[INIT]) return;
    root.dataset[INIT] = '1';

    // SCOPED: this block's own map, never the page's first one.
    var mapEl = root.querySelector('[data-itc-variant-map]');
    if (!mapEl) return;
    var variantMap;
    try { variantMap = JSON.parse(mapEl.textContent); } catch (e) { return; }

    var cc = root.getAttribute('data-itc-country') || 'US';
    var countryName = root.getAttribute('data-itc-country-name') || 'your country';
    var line = root.querySelector('[data-itc-delivery-line]');
    var nudge = root.querySelector('[data-itc-delivery-nudge]');

    function render(variantId) {
      if (!variantId || !(String(variantId) in variantMap)) return;
      var cv = variantMap[String(variantId)];
      var w = windowFor(cv, cc, variantId);
      if (line) line.textContent = sentence(w, countryName, cc);

      if (!nudge) return;
      nudge.hidden = true;
      if (!w) return;
      var best = null;
      Object.keys(variantMap).forEach(function (vid) {
        var o = windowFor(variantMap[vid], cc, vid);
        if (o && (!best || o.hi < best.hi)) best = { hi: o.hi, lo: o.lo, vid: vid };
      });
      if (best && best.hi < w.hi) {
        // SCOPED: look for the option inside this block's own form.
        var opt = form && form.querySelector('[name="id"] option[value="' + best.vid + '"]');
        var label = opt ? (opt.textContent || '').split('-')[0].trim() : '';
        nudge.textContent = label
          ? label + ' arrives in ' + best.lo + '–' + best.hi + ' days.'
          : 'Another colour arrives in ' + best.lo + '–' + best.hi + ' days.';
        nudge.hidden = false;
      }
    }

    // SCOPED: the form this block lives in - never the document.
    var form = root.closest('form') || root.closest('product-form-component');

    render(root.getAttribute('data-itc-selected'));

    if (form) {
      form.addEventListener('change', function (e) {
        var t = e.target;
        if (t && t.name === 'id') { render(t.value); return; }
        var hidden = form.querySelector('[name="id"]');
        if (hidden) render(hidden.value);
      });
      var hidden = form.querySelector('[name="id"]');
      if (hidden && window.MutationObserver) {
        new MutationObserver(function () { render(hidden.value); })
          .observe(hidden, { attributes: true, attributeFilter: ['value'] });
      }
    }
  }

  function initCart(root) {
    if (root.dataset[INIT]) return;
    root.dataset[INIT] = '1';
    var mapEl = root.querySelector('[data-itc-cart-map]');
    if (!mapEl) return;
    var lines;
    try { lines = JSON.parse(mapEl.textContent); } catch (e) { return; }
    var cc = root.getAttribute('data-itc-country') || 'US';
    var countryName = root.getAttribute('data-itc-country-name') || 'your country';
    var out = root.querySelector('[data-itc-delivery-line]');
    var slowest = null;
    lines.forEach(function (l) {
      var w = windowFor(l.cv, cc);
      if (w && (!slowest || w.hi > slowest.hi)) slowest = w;
    });
    if (out) {
      out.textContent = slowest
        ? 'Your order arrives in ' + slowest.lo + '–' + slowest.hi +
          ' business days to ' + countryName + '.'
        : 'Delivery calculated at checkout.';
    }
  }

  function boot() {
    // ALL blocks, each on its own. Idempotent, so re-running is safe.
    var ps = document.querySelectorAll('[data-itc-delivery]');
    for (var i = 0; i < ps.length; i++) initProduct(ps[i]);
    var cs = document.querySelectorAll('[data-itc-delivery-cart]');
    for (var j = 0; j < cs.length; j++) initCart(cs[j]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('itc:offer-applied', boot);
})();
